import React, { useEffect, useState, useMemo } from 'react'
import DatePicker from 'react-datepicker'
import { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import to from 'await-catch'
import { Formik } from 'formik'
import MapContainer from '../../../../components/map/MapContainer'
import Select from '../../../../components/ui/select'
import { getAvailableAppointments } from '../../../../api'
import { connect } from 'react-redux'
import { addFlashMessage, hideLoader, showLoader } from '../../../../actions'
import {
	Container,
	Header,
	MobileToggle,
	ToggleButton,
	Title,
	SearchSection,
	EditSearchSection,
	FilterGrid,
	FilterGroup,
	FilterLabel,
	DatePickerWrapper,
	SearchButtonsContainer,
	SearchButton,
	CancelButton,
	SearchInfo,
	SearchText,
	SearchTextDesc,
	EditButton,
	ContentWrapper,
	Sidebar,
	ResultsCount,
	FilterToggle,
	Toggle,
	ToggleInput,
	ToggleSlider,
	ResultsList,
	ResultCard,
	DoctorName,
	Specialty,
	ClinicInfo,
	Icon,
	AppointmentInfo,
	BookButton,
	MapWrapper,
	FiltersModal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalTitle,
	CloseButton,
	ModalFilterGrid,
	ModalFooter,
	ClinicModalWrapper,
	ClinicModalOverlay,
	ClinicModalContent,
	ClinicModalHeader,
	ClinicModalTitle,
	ClinicResultsCount,
	ClinicCloseButton,
	ClinicDoctorsList,
	ClinicDoctorCard,
	ClinicDoctorName,
	ClinicDoctorSpecialty,
	ClinicLocationInfo,
	ClinicAppointmentInfo,
	ClinicBookButton,
	SearchDiv,
	SearchHeader
} from './styled'
import { cleanParams } from '../../../../utils/cleanParams'
import moment from 'moment'
import { Edit, SearchIcon, Calendar, Address, ChevronLeft, SadFace, ListMobile, Map } from '../../../../assets/icons'
import { capitalizeEachWord } from '../../../../utils/stringsUtils'
import { BackTitle } from '../../EmergencyRoom/styled'
import Autocomplete from '../../../../components/ui/autoComplete'
import EmptyState from '../../../../components/emptyState'
import { Button } from '../../../../components/ui/button'
import theme from '../../../../styled/theme'
import useIsMobile from '../../../../hooks/useIsMobile'

registerLocale('es', es)

const formatTimeToHHmmss = timeValue => {
	if (!timeValue) return null
	if (typeof timeValue === 'string') return timeValue
	if (timeValue instanceof Date) {
		return timeValue.toLocaleTimeString('es-AR', {
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit'
		})
	}
	return null
}

const validateDateAndTimeRanges = values => {
	const errors = {}

	if ((values.dateFrom && !values.dateTo) || (!values.dateFrom && values.dateTo)) {
		errors.dateRange = 'Debes seleccionar ambas fechas o ninguna'
	}

	if ((values.hourFrom && !values.hourTo) || (!values.hourFrom && values.hourTo)) {
		errors.timeRange = 'Debes seleccionar ambas horas o ninguna'
	}

	return errors
}

const groupTurnosByProfessionalClinic = (turnos = []) => {
	const groups = {}
	turnos.forEach(t => {
		const key = `${t.idProfesional}-${t.clinica}`
		const dt = new Date(t.fechaTurnoDateTime)
		if (!groups[key]) {
			groups[key] = {
				idTurno: key,
				idProfesional: t.idProfesional,
				clinica: t.clinica,
				nombreProfesional: t.nombreProfesional,
				idEspecialidad: t.idEspecialidad,
				nombreEspecialidad: t.nombreEspecialidad,
				latitud: t.latitud,
				longitud: t.longitud,
				direccion: t.direccion,
				count: 1,
				nextTurnoDateTime: dt,
				fechaTurno: t.fechaTurno,
				turnos: [t]
			}
		} else {
			const g = groups[key]
			g.count += 1
			g.turnos.push(t)
			if (dt < g.nextTurnoDateTime) {
				g.nextTurnoDateTime = dt
				g.fechaTurno = t.fechaTurno
			}
			if (!g.latitud && t.latitud) g.latitud = t.latitud
			if (!g.longitud && t.longitud) g.longitud = t.longitud
			if (!g.direccion && t.direccion) g.direccion = t.direccion
		}
	})
	return Object.values(groups)
}

const SearchMap = ({
	onNext,
	onUpdateFormData,
	formData,
	clinics,
	specialties,
	professionals,
	professionalsKey,
	onBack,
	patient,
	showLoader,
	hideLoader,
	saveAppointments,
	getProfessionals,
	addFlashMessage
}) => {
	const [showNext7Days, setShowNext7Days] = useState(false)
	const [mapCenter, setMapCenter] = useState({ lat: -34.5829, lng: -58.4421 })
	const [zoom, setZoom] = useState(13)
	const [selectedMedicId, setSelectedMedicId] = useState(null)
	const [isEditingSearch, setIsEditingSearch] = useState(false)
	const [showFiltersModal, setShowFiltersModal] = useState(false)
	const [groupedMedics, setGroupedMedics] = useState([])
	const [appointments, setAppointments] = useState([])
	const [showMap, setShowMap] = useState(false)
	const [selectedClinicModal, setSelectedClinicModal] = useState(null)
	const [specialtyName, setSpecialtyName] = useState('')
	const [submittedFilters, setSubmittedFilters] = useState(formData)
	const [searchTrigger, setSearchTrigger] = useState(0)
	const [isLoadingProfessionals, setIsLoadingProfessionals] = useState(false)
	const [loadedProfessionalsKey, setLoadedProfessionalsKey] = useState(professionalsKey)
	const isMobile = useIsMobile()
	useEffect(() => {
		setSpecialtyName(specialties.find(s => s.value === formData.speciality)?.label || '')
	}, [formData.speciality])

	const handleMapPositionChange = (newZoom, newCenter) => {
		setZoom(newZoom)
		setMapCenter(newCenter)
	}

	const handleSelectMarker = medicId => {
		setSelectedMedicId(medicId)
		if (window.innerWidth <= 768) {
			const medic = groupedMedics.find(m => m.idTurno === medicId)
			if (medic) {
				setSelectedClinicModal(medic)
			}
		}
	}

	const handleSelectCard = medicId => {
		setSelectedMedicId(medicId)
		const medic = groupedMedics.find(m => m.idTurno === medicId)
		if (medic) {
			setMapCenter({ lat: medic.latitud, lng: medic.longitud })
			setZoom(15)
		}
	}

	const handleBack = () => {
		onBack()
	}

	const handleBookAppointment = (medicId, clinic) => {
		const filteredAppointments = appointments.filter(
			t => t.idProfesional === medicId && t.clinica === clinic
		)
		saveAppointments(filteredAppointments)
		onNext()
	}

	useEffect(() => {
		const fetchTurnos = async params => {
			try {
				showLoader()
				const [err, data] = await to(getAvailableAppointments(params))

				if (err) {
					console.error('Error en API:', err)
					throw new Error('Error al obtener los turnos')
				}

				let allTurnos = []

				if (Array.isArray(data.data)) {
					allTurnos = data.data.flatMap(dayGroup => {
						return dayGroup?.turnos && Array.isArray(dayGroup.turnos) ? dayGroup.turnos : []
					})
				}

				if (allTurnos.length === 0) console.warn('No se encontraron turnos en la respuesta')

				setAppointments(allTurnos)
				const grouped = groupTurnosByProfessionalClinic(allTurnos)
				setGroupedMedics(grouped)
			} catch (error) {
				console.error('Error en fetchTurnos:', error)
				addFlashMessage('Ocurrió un error cargando los turnos')
			} finally {
				hideLoader()
			}
		}

		let fechaDesde, fechaHasta
		if (submittedFilters?.dateFrom && submittedFilters?.dateTo) {
			fechaDesde = moment(submittedFilters.dateFrom).format('YYYY-MM-DD')
			fechaHasta = moment(submittedFilters.dateTo).format('YYYY-MM-DD')
		} else {
			fechaDesde = moment().format('YYYY-MM-DD')
			fechaHasta = moment()
				.add(1, 'month')
				.format('YYYY-MM-DD')
		}

		let horaDesde, horaHasta
		if (submittedFilters?.hourFrom && submittedFilters?.hourTo) {
			horaDesde = formatTimeToHHmmss(submittedFilters.hourFrom)
			horaHasta = formatTimeToHHmmss(submittedFilters.hourTo)
		} else {
			horaDesde = '00:00:00'
			horaHasta = '23:59:59'
		}

		const rawParams = {
			idObraSocial: patient.idObraSocial,
			idPlan: patient.idPlan,
			clinica: submittedFilters?.clinic,
			idEspecialidad: submittedFilters?.speciality,
			idProfesional: submittedFilters?.professional,
			fechaDesde: fechaDesde,
			fechaHasta: fechaHasta,
			horaDesde: horaDesde,
			horaHasta: horaHasta,
			idSistema: ''
		}

		const params = cleanParams(rawParams)

		fetchTurnos(params)
	}, [searchTrigger])

	const handleSearchSubmit = (values, closeEditor) => {
		onUpdateFormData(values)
		setSubmittedFilters(values)
		setSearchTrigger(prev => prev + 1)
		closeEditor()
	}

	const displayedMedics = useMemo(() => {
		if (!showNext7Days) return groupedMedics
		const now = new Date()
		const cutoff = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)
		return groupedMedics.filter(g => {
			return (
				g.nextTurnoDateTime instanceof Date &&
				g.nextTurnoDateTime >= now &&
				g.nextTurnoDateTime <= cutoff
			)
		})
	}, [groupedMedics, showNext7Days])

	const onChangeSpeciality = (speciality, setFieldValue) => {
		setLoadedProfessionalsKey(null)
		setFieldValue('speciality', speciality)
		setFieldValue('professional', null)
		setFieldValue('clinic', null)
		setFieldValue('clinicCode', null)
	}

	const onChangeClinic = (e, setFieldValue, speciality) => {
		const clinicValue = e?.target?.value ?? e
		const clinicOption = clinics.find(c => c.value === clinicValue)
		setLoadedProfessionalsKey(null)
		setFieldValue('professional', null)
		setFieldValue('clinic', clinicValue)
		setFieldValue('clinicCode', clinicOption?.codigoEmpresa || '')
	}
	const getProfessionalsKey = (speciality, clinicCode) =>
		clinicCode && speciality ? `${speciality}-${clinicCode}` : null

	const getClinicOptions = (clinicCode, speciality) => {
		const requestKey = getProfessionalsKey(speciality, clinicCode)

		if (!requestKey || isLoadingProfessionals) {
			return false
		}

		if (loadedProfessionalsKey === requestKey && professionals.length > 0) {
			return false
		}

		setIsLoadingProfessionals(true)

		Promise.resolve(getProfessionals(speciality, clinicCode))
			.then(() => {
				setLoadedProfessionalsKey(requestKey)
			})
			.finally(() => {
				setIsLoadingProfessionals(false)
			})

		return true
	}

	const createSelectedFiltersText = () => {
		const filters = []

		if (formData.clinic) {
			const clinicLabel = clinics.find(c => c.value === formData.clinic)?.label || ''
			if (clinicLabel) filters.push(clinicLabel)
		}

		if (formData.professional) {
			const professionalLabel =
				professionals.find(p => p.value === formData.professional)?.label || ''
			if (professionalLabel) filters.push(professionalLabel)
		}
		if (formData.dateFrom && formData.dateTo) {
			const dateFromFormatted = moment(formData.dateFrom).format('DD/MM/YYYY')
			const dateToFormatted = moment(formData.dateTo).format('DD/MM/YYYY')
			filters.push(`${dateFromFormatted} - ${dateToFormatted}`)
		} else if (formData.dateFrom) {
			filters.push(moment(formData.dateFrom).format('DD/MM/YYYY'))
		} else if (formData.dateTo) {
			filters.push(moment(formData.dateTo).format('DD/MM/YYYY'))
		}
		if (formData.hourFrom && formData.hourTo) {
			const hourFromFormatted = formatTimeToHHmmss(formData.hourFrom)
			const hourToFormatted = formatTimeToHHmmss(formData.hourTo)
			filters.push(`${hourFromFormatted} - ${hourToFormatted}`)
		}

		return filters.join(' - ')
	}

	const renderMobileViewToggle = overlay => (
    <MobileToggle $overlay={overlay}>
      {showMap ? (
        <ToggleButton onClick={() => setShowMap(false)}>
          <ListMobile />
          Lista
        </ToggleButton>
      ) : (
        <ToggleButton onClick={() => setShowMap(true)}>
          <Map />
          Mapa
        </ToggleButton>
      )}
    </MobileToggle>
  )

	return (
		<Container>
			<Header>
				<BackTitle m={'0'} onClick={handleBack}>
					<ChevronLeft size={8} /> Volver
				</BackTitle>
				<Title>Resultados de tu búsqueda</Title>
			</Header>

			<SearchSection>
				{!isEditingSearch ? (
					<SearchHeader>
						<SearchDiv>
							<SearchIcon />
							<SearchInfo>
								<SearchText>{specialtyName}</SearchText>
								<SearchTextDesc>{createSelectedFiltersText()}</SearchTextDesc>
							</SearchInfo>
						</SearchDiv>
						<EditButton
							onClick={() => {
								if (window.innerWidth <= 768) {
									setShowFiltersModal(true)
								} else {
									setIsEditingSearch(true)
								}
							}}
						>
							{isMobile ? 'Editar' : 'Editar búsqueda'}
							<Edit />
						</EditButton>
					</SearchHeader>
				) : (
					<Formik
						initialValues={formData}
						enableReinitialize={true}
						validate={validateDateAndTimeRanges}
						onSubmit={(values, { setErrors }) => {
							const validationErrors = validateDateAndTimeRanges(values)
							if (Object.keys(validationErrors).length > 0) {
								setErrors(validationErrors)
								return
							}
							handleSearchSubmit(values, () => setIsEditingSearch(false))
						}}
					>
						{({ values, handleSubmit, setFieldValue, errors }) => (
							<EditSearchSection>
								<h3 style={{ margin: '0 0 20px 0', fontSize: '18px' }}>{isMobile ? 'Editar' : 'Editar búsqueda'}</h3>
								<FilterGrid>
									<FilterGroup>
										<Autocomplete
											label="Especialidad"
											name="speciality"
											value={values.speciality}
											onChange={e => onChangeSpeciality(e.target?.value ?? e, setFieldValue)}
											options={specialties}
										/>
									</FilterGroup>

									<FilterGroup>
										<Autocomplete
											value={values.clinic}
											label="Clínica / Centro médico"
											onChange={e => onChangeClinic(e, setFieldValue, values.speciality)}
											disabled={values.speciality == null || values.speciality === ''}
											options={clinics}
											placeholder={
												!values.speciality
													? 'Primero seleccione una especialidad'
													: 'Seleccionar clinica'
											}
										/>
									</FilterGroup>

									<FilterGroup>
										<Autocomplete
											label="Profesional (Opcional)"
											name="professional"
											value={values.professional}
											onChange={e => setFieldValue('professional', e.target?.value || '')}
												onOpenRequest={
													loadedProfessionalsKey === getProfessionalsKey(values.speciality, values.clinicCode) && professionals.length > 0
														? undefined
														: () => getClinicOptions(values.clinicCode, values.speciality)
												}
												openOnFocus
												isLoading={isLoadingProfessionals}
												options={
													loadedProfessionalsKey === getProfessionalsKey(values.speciality, values.clinicCode)
														? professionals
														: []
												}
												isClearable
												disabled={!values.speciality || !values.clinic}
												placeholder={
													!values.speciality || !values.clinic
														? 'Primero seleccione especialidad y clínica'
														: 'Seleccionar...'
												}
											/>
										</FilterGroup>

										<FilterGroup>
											<FilterLabel>Fecha del turno</FilterLabel>
											<DatePickerWrapper>
												<DatePicker
													selectsRange
													startDate={values.dateFrom}
													endDate={values.dateTo}
													onChange={dates => {
														const [from, to] = dates
														setFieldValue('dateFrom', from)
														setFieldValue('dateTo', to)
													}}
													placeholderText="Seleccionar..."
													locale="es"
													dateFormat="dd/MM/yyyy"
													isClearable
												/>
											</DatePickerWrapper>
										{errors.dateRange && (
											<div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
												{errors.dateRange}
											</div>
										)}
									</FilterGroup>

									<FilterGroup>
										<FilterLabel>Rango horario</FilterLabel>
										<DatePickerWrapper>
                      						<div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
												<DatePicker
													selected={values.hourFrom}
													onChange={date => setFieldValue('hourFrom', date)}
													showTimeSelect
													showTimeSelectOnly
													timeIntervals={30}
													timeCaption="Desde"
													dateFormat="HH:mm"
													placeholderText="Desde"
													isClearable
												/>
												<DatePicker
													selected={values.hourTo}
													onChange={date => setFieldValue('hourTo', date)}
													showTimeSelect
													showTimeSelectOnly
													timeIntervals={30}
													timeCaption="Hasta"
													dateFormat="HH:mm"
													placeholderText="Hasta"
													isClearable
												/>
											</div>
										</DatePickerWrapper>
										{errors.timeRange && (
											<div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
												{errors.timeRange}
											</div>
										)}
									</FilterGroup>
								</FilterGrid>

								<SearchButtonsContainer>
									<Button
										onClick={handleSubmit}
										type="submit"
										label={'Buscar'}
										size={'small'}
										disabled={!values.speciality || !values.clinic}
									/>
									<CancelButton
										onClick={() => {
											setIsEditingSearch(false)
										}}
									>
										Cancelar
									</CancelButton>
								</SearchButtonsContainer>
							</EditSearchSection>
						)}
					</Formik>
				)}
			</SearchSection>
			{showFiltersModal && (
				<Formik
					initialValues={formData}
					enableReinitialize={true}
					validate={validateDateAndTimeRanges}
					onSubmit={(values, { setErrors }) => {
						const validationErrors = validateDateAndTimeRanges(values)
						if (Object.keys(validationErrors).length > 0) {
							setErrors(validationErrors)
							return
						}
						handleSearchSubmit(values, () => setShowFiltersModal(false))
					}}
				>
					{({ values, handleSubmit, setFieldValue, errors }) => (
						<FiltersModal>
							<ModalOverlay onClick={() => setShowFiltersModal(false)} />
							<ModalContent>
								<ModalHeader>
									<ModalTitle>Filtros</ModalTitle>
									<CloseButton onClick={() => setShowFiltersModal(false)}>✕</CloseButton>
								</ModalHeader>

								<ModalFilterGrid>
									<FilterGroup>
										<Autocomplete
											label="Especialidad"
											name="speciality"
											value={values.speciality}
											onChange={e => onChangeSpeciality(e.target?.value ?? e, setFieldValue)}
											options={specialties}
										/>
									</FilterGroup>

									<FilterGroup>
										<Autocomplete
											label="Clínica / Centro médico"
											name="clinic"
											value={values.clinic}
											onChange={e => onChangeClinic(e, setFieldValue, values.speciality)}
											disabled={values.speciality == null || values.speciality === ''}
											options={clinics}
											placeholder={
												values.speciality == null || values.speciality === ''
													? 'Primero seleccione una especialidad'
													: 'Seleccionar clinica'
											}
										/>
									</FilterGroup>

									<FilterGroup>
										<Autocomplete
											label="Profesional (Opcional)"
											name="professional"
											value={values.professional}
											onChange={e => {
												const val = e.target?.value || null
												setFieldValue('professional', val)

											}}
											onOpenRequest={
												loadedProfessionalsKey === getProfessionalsKey(values.speciality, values.clinicCode) && professionals.length > 0
													? undefined
													: () => getClinicOptions(values.clinicCode, values.speciality)
											}
											openOnFocus
											isLoading={isLoadingProfessionals}
											options={
												loadedProfessionalsKey === getProfessionalsKey(values.speciality, values.clinicCode)
													? professionals
													: []
											}
											isClearable
											disabled={!values.speciality || !values.clinic}
											placeholder={
												!values.speciality
													? 'Primero seleccione una especialidad'
													: !values.clinic
													? 'Primero seleccione una clínica'
													: 'Seleccionar...'
											}
										/>
									</FilterGroup>

									<FilterGroup>
										<FilterLabel>Fecha del turno</FilterLabel>
										<DatePickerWrapper>
											<DatePicker
												selectsRange
												startDate={values.dateFrom}
												endDate={values.dateTo}
												onChange={dates => {
													const [from, to] = dates
													setFieldValue('dateFrom', from)
													setFieldValue('dateTo', to)
												}}
												placeholderText="Seleccionar..."
												locale="es"
												dateFormat="dd/MM/yyyy"
												isClearable
											/>
										</DatePickerWrapper>
										{errors.dateRange && (
											<div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
												{errors.dateRange}
											</div>
										)}
									</FilterGroup>

									<FilterGroup>
										<FilterLabel>Rango horario</FilterLabel>
										<DatePickerWrapper>
											<div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>												<DatePicker
													selected={values.hourFrom}
													onChange={date => setFieldValue('hourFrom', date)}
													showTimeSelect
													showTimeSelectOnly
													timeIntervals={30}
													timeCaption="Desde"
													dateFormat="HH:mm"
													placeholderText="Desde"
													isClearable
												/>
												<DatePicker
													selected={values.hourTo}
													onChange={date => setFieldValue('hourTo', date)}
													showTimeSelect
													showTimeSelectOnly
													timeIntervals={30}
													timeCaption="Hasta"
													dateFormat="HH:mm"
													placeholderText="Hasta"
													isClearable
												/>
											</div>
										</DatePickerWrapper>
										{errors.timeRange && (
											<div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
												{errors.timeRange}
											</div>
										)}
									</FilterGroup>
								</ModalFilterGrid>

								<ModalFooter>
									<SearchButton width={'100%'} onClick={handleSubmit}>
										Buscar
									</SearchButton>
								</ModalFooter>
							</ModalContent>
						</FiltersModal>
					)}
				</Formik>
			)}

			{displayedMedics?.length === 0 ? (
				<EmptyState isSearch={true} actionButton={false} />
			) : (
				<ContentWrapper>
					<Sidebar $hidden={showMap}>
						<ResultsCount>{displayedMedics.length} resultados</ResultsCount>
						{renderMobileViewToggle(false)}
						<FilterToggle>
							<span>Turnos para los próximos 7 días</span>
							<Toggle>
								<ToggleInput
									type="checkbox"
									checked={showNext7Days}
									onChange={e => setShowNext7Days(e.target.checked)}
								/>
								<ToggleSlider />
							</Toggle>
						</FilterToggle>

						<ResultsList>
							{displayedMedics.map(medic => (
								<ResultCard
									key={medic.idTurno}
									isSelected={selectedMedicId === medic.idTurno}
									onClick={() => handleSelectCard(medic.idTurno)}
								>
									<DoctorName>{capitalizeEachWord(medic.nombreProfesional)}</DoctorName>
									<Specialty>{capitalizeEachWord(medic.nombreEspecialidad)}</Specialty>
									<ClinicInfo>
										<Address />
										<div>
											<div>
												{capitalizeEachWord(
													clinics.find(x => x.codigoEmpresa == medic.clinica)?.nombre || ''
												)}
											</div>
											<div style={{ textDecoration: 'underline' }}>{medic.direccion}</div>
										</div>
									</ClinicInfo>
									<AppointmentInfo>
										<Calendar size={16} color="#161616" />
										<span>
											Próximo turno: <strong>{medic.fechaTurno}</strong>
										</span>
									</AppointmentInfo>
									<BookButton
										onClick={() => handleBookAppointment(medic.idProfesional, medic.clinica)}
									>
										Sacar turno
									</BookButton>
								</ResultCard>
							))}
						</ResultsList>
					</Sidebar>
					<MapWrapper>
						{showMap && renderMobileViewToggle(true)}
						<MapContainer
							medics={displayedMedics}
							mapCenterSearched={mapCenter}
							radius={2000}
							onMapPositionChange={handleMapPositionChange}
							selectedMedicId={selectedMedicId}
							onSelectMarker={handleSelectMarker}
							zoom={zoom}
							mapCenter={mapCenter}
							$hidden={!showMap}
						/>
					</MapWrapper>
				</ContentWrapper>
			)}

			{selectedClinicModal && (
				<ClinicModalWrapper>
					<ClinicModalOverlay onClick={() => setSelectedClinicModal(null)} />
					<ClinicModalContent>
						<ClinicModalHeader>
							<div>
								<ClinicModalTitle>{selectedClinicModal.clinica}</ClinicModalTitle>
								<ClinicResultsCount>
									{appointments.filter(a => a.clinica === selectedClinicModal.clinica).length}{' '}
									resultados
								</ClinicResultsCount>
							</div>
							<ClinicCloseButton onClick={() => setSelectedClinicModal(null)}>✕</ClinicCloseButton>
						</ClinicModalHeader>

						<ClinicDoctorsList>
							{groupedMedics
								.filter(a => a.clinica === selectedClinicModal.clinica)
								.map((doctor, idx) => (
									<ClinicDoctorCard key={idx}>
										<ClinicDoctorName>
											{capitalizeEachWord(doctor.nombreProfesional)}
										</ClinicDoctorName>
										<ClinicDoctorSpecialty>
											{capitalizeEachWord(doctor.nombreEspecialidad)}
										</ClinicDoctorSpecialty>
										<ClinicLocationInfo>
											<Address />
											<div>
												<div>
													{capitalizeEachWord(
														clinics.find(x => x.codigoEmpresa === doctor.clinica)?.nombre || ''
													)}
												</div>
												<div style={{ textDecoration: 'underline' }}>{doctor.direccion}</div>
											</div>
										</ClinicLocationInfo>
										<ClinicAppointmentInfo>
											<Calendar size={16} color="#161616" />
											<span>Próximo turno: {doctor.fechaTurno}</span>
										</ClinicAppointmentInfo>
										<ClinicBookButton
											onClick={() => {
												handleBookAppointment(doctor.idProfesional, doctor.clinica)
												setSelectedClinicModal(null)
											}}
										>
											Sacar turno
										</ClinicBookButton>
									</ClinicDoctorCard>
								))}
						</ClinicDoctorsList>
					</ClinicModalContent>
				</ClinicModalWrapper>
			)}
		</Container>
	)
}

function mapStateToProps({ patient }) {
	return { patient }
}

const mapDispatchToProps = {
	showLoader,
	hideLoader,
	addFlashMessage
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchMap)
